import AuthPanel from '@components/v2/layout/AuthPanel/AuthPanel';
import Button from '@components/v2/ui/Button/Button';
import Loading from '@components/v2/ui/Loading/Loading';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { useId } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { SsoCallbackPageTestIds } from '../../../utils/testIds/SsoCallbackPage.testIds';
import AuthShell from '../../login/components/AuthShell';
import TeamSelectModal from '../../login/components/TeamSelectModal/TeamSelectModal';
import UserSelectModal from '../../login/components/UserSelectModal/UserSelectModal';
import { useTranslation } from '../../translation/TranslationContext';
import useSsoCallback from '../hooks/useSsoCallback';

const visuallyHiddenSx = {
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
} as const;

const SsoCallbackPage = () => {
  const { translate } = useTranslation();
  const loadingLabelId = useId();
  const {
    errorMessage,
    brandLoginPath,
    userInfo,
    openTeamModal,
    handleSelectTeam,
    openUsersModal,
    handleSelectPersonatedUser,
    handleCancelSelection,
  } = useSsoCallback();

  return (
    <>
      <TeamSelectModal
        title={LangEnum.TEAM_MODAL_CHOOSE_TEAM_TITLE}
        open={openTeamModal}
        teams={userInfo.teams}
        onClick={handleSelectTeam}
        onClose={handleCancelSelection}
      />
      <UserSelectModal
        title={translate(LangEnum.TEAM_MODAL_GREETINGS_TEXT, { user: userInfo?.user?.name })}
        open={openUsersModal}
        onClose={handleCancelSelection}
        onClick={handleSelectPersonatedUser}
      />
      <AuthShell>
        <AuthPanel>
          {errorMessage ? (
            <Stack role="alert" sx={{ alignItems: 'center', gap: 2, textAlign: 'center' }}>
              <Typography variant="h5">{translate(LangEnum.SSO_CALLBACK_ERROR_TITLE)}</Typography>
              <Typography variant="body2" color="text.secondary">
                {errorMessage}
              </Typography>
              <Button variant="text" color="secondary" to={brandLoginPath}>
                {translate(LangEnum.GLOBAL_GO_BACK_TO_LOGIN)}
              </Button>
            </Stack>
          ) : (
            <Stack sx={{ alignItems: 'center', gap: 2 }}>
              <Typography id={loadingLabelId} variant="body2" sx={visuallyHiddenSx}>
                {translate(LangEnum.GLOBAL_LOADING)}
              </Typography>
              <Loading
                size={48}
                aria-labelledby={loadingLabelId}
                testId={SsoCallbackPageTestIds.PROGRESS}
              />
            </Stack>
          )}
        </AuthPanel>
      </AuthShell>
    </>
  );
};

export default SsoCallbackPage;
